export default function (Vuex) {
  return new Vuex.Store({
    strict: process.env.NODE_ENV !== 'production',
    state: {
      global: {
        currentTheme: 'light',
        currentBaseUrl: ''
      }
    },
    getters: {      
      isSerasa: state => {
        return state.global.currentTheme === 'serasa'
      },
      currentBaseUrl: state => {
        return state.global.currentBaseUrl
      }
    },
    mutations: {
      updateGlobal (state, payload) {
        state.global = Object.assign({}, state.global, payload);        
      },
      updateCurrentBaseUrl(state, baseUrl) {
        state.global.currentBaseUrl = baseUrl;        
      },

    },
    actions: {
      setCurrentTheme({ commit }, theme) {
        commit('updateGlobal', { currentTheme: theme });
      },
      setCurrentBaseUrl({ commit }, baseUrl) {
        commit('updateGlobal', { currentBaseUrl: baseUrl });
      }
    }
  })
}
